import CoFormLayout from './components/co-form-layout'
import { CoQueryWrapper } from './components/co-query-wrapper'

export type CreateCoParameter =
  | {
      billIds: string[]
      productionAssignedIds: string[]
      depositDocumentIds: string[]
    }
  | {
      createReceiptZero: true
      reservationId: string
    }

export type UpdateCoParameter = {
  documentId: string
}

export type CheckoutDocumentFormProps = {
  propertyId: string
  open: boolean
  onClose: () => void
  onSuccess?: (props: { closedBillsIds?: string[]; documentId: string }) => void
  onCreditNoteSuccess: (creditNoteId: string, manualDocumentId?: string) => void
  onOpenReferenceDocument?: (documentId: string) => void
  refetchQueries?: string[]
} & (CreateCoParameter | UpdateCoParameter)

export default function CheckoutDocumentForm(props: CheckoutDocumentFormProps) {
  const { propertyId, open, onClose, onSuccess, refetchQueries, onCreditNoteSuccess, onOpenReferenceDocument, ...parameterProps } = props

  if (open) {
    return (
      <CoQueryWrapper //
        propertyId={propertyId}
        {...parameterProps}
        children={(data, onDocumentUpserted) => (
          <CoFormLayout //
            propertyId={propertyId}
            open={open}
            onClose={onClose}
            queryData={data}
            onDocumentUpserted={(documentId, closedBillsIds) => {
              onDocumentUpserted(documentId)
              onSuccess?.({ closedBillsIds, documentId })
            }}
            refetchQueries={refetchQueries}
            onCreditNoteCreated={(creditNoteId: string, manualDocumentId?: string) => onCreditNoteSuccess(creditNoteId, manualDocumentId)}
            onOpenReferenceDocument={onOpenReferenceDocument}
            createReceiptZero={'createReceiptZero' in parameterProps ? parameterProps.createReceiptZero : undefined}
          />
        )}
      />
    )
  } else {
    return <></>
  }
}
